import { authPost } from "../../common/redux/ApiClient";

const baseUrl = "35.240.204.237/es3KioskApi";

export function callDashboardList(params) {
  return authPost(`${baseUrl}/Agent14.ashx`, params);
}

export function postAgent18(params) {
  return authPost(`${baseUrl}/Agent18.ashx`, params);
}
